export default {
  path: 'winter-service/v2/bases',
  name: 'WinterService2Bases',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/BasesIndex.vue')
}
